<span [style.text-transform]="text_transform">
  <ng-content></ng-content>
</span>
